<button
  class="{{classes}}"
  [style]="styles"
    [ngClass]="{
        'tooltip-disabled' : disabledRecolorClass,
        'btn--active' : active,
        }"
  [disabled]="preloading || buttonDisabled"
  #buttonEl
  >
  <span #buttonContent data-cy="button-hoverable">
    @if (!preloading) {
      <div class="button-layout">
        @if (svgIcon) {
          <svg-icon [src]="iconPath()" [svgStyle]="iconStyles()"></svg-icon>
        }
        {{ uppercase ? (label | uppercase) : label }}
      </div>
    } @else {
      <div class="preload-disable">
        <libero-preload-spinner [inverse]="preloaderInverse" [responsive]="smallSecondary"></libero-preload-spinner>
      </div>
    }
  </span>
</button>

<div #tooltipContainerEl style="display: none;">
  @if (disabledTooltipText) {
    <div class="tooltip-content" data-cy="btn-disabled-tooltip-content">
      <div class="explain-tooltip-content explain-tooltip-text">
        <p innerHTML="{{ tooltipUseTranslateKey ? ('global.tooltips.' + disabledTooltipText | translate) : disabledTooltipText }}"></p>
      </div>
    </div>
  }
</div>
